import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import purpleButton from "@/components/purpleButton/purpleButton.vue";
import Nav from "@/components/nav/navBar.vue";
import EventBus from "@/utils/eventBus";
import { Radar, Sexangle } from "@/utils/canvasAnimation";
import { i18n } from "@/i18n/i18n-setup";
import LoadingProgressBar from "@/components/progressBar/loadingProgressBar.vue";
import MyReportButton from "@/components/myReportButton/myReportButton.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { getLang } from '@/api/utils/apiHelper';

var GetMyReport =
/*#__PURE__*/
function (_Vue) {
  _inherits(GetMyReport, _Vue);

  function GetMyReport() {
    var _this;

    _classCallCheck(this, GetMyReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GetMyReport).apply(this, arguments));
    _this.age_shutter_img = _this.$remoteImg("icons/home/age_shutter_88.gif"); // aging shutter模块展示默认gif图

    _this.button_status = "get";
    _this.dataIsOk = false; //数据是否已经准备好

    _this.paramsMap = {
      Gender: [i18n.t("get_my_report.Gender[0]"), i18n.t("get_my_report.Gender[1]"), i18n.t("get_my_report.unlimited_acess")],
      Aging: [i18n.t("get_my_report.Aging[0]"), i18n.t("get_my_report.Aging[1]"), i18n.t("get_my_report.unlimited_acess")],
      Ethnicity: [i18n.t("get_my_report.Ethnicity[0]"), i18n.t("get_my_report.Ethnicity[1]"), i18n.t("get_my_report.unlimited_acess")],
      Future: [i18n.t("get_my_report.Future[0]"), i18n.t("get_my_report.Future[1]"), i18n.t("get_my_report.unlimited_acess")]
    };
    _this.button_text = i18n.t("get_my_report.button_text");
    return _this;
  }

  _createClass(GetMyReport, [{
    key: "goBackHome",
    value: function goBackHome() {
      this.goBack && this.goBack();
      EventBus.$emit("isShowGetMyReport", {
        isShow: false
      });
    }
  }, {
    key: "clickRateUs",
    value: function clickRateUs() {
      console.log("clickRateUs");
      this.rateUsFn ? this.rateUsFn() : void 0;
    }
  }, {
    key: "watchStatus",
    value: function () {
      var _watchStatus = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(val) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.button_status = this.buttonStatus;

                if (!(this.button_status === "loading")) {
                  _context.next = 18;
                  break;
                }

                console.log("requestResult", this.requestResult);

                if (!this.requestResult) {
                  _context.next = 17;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return this.requestResult();

              case 7:
                result = _context.sent;
                result ? this.dataIsOk = true : this.button_status = "retry"; // this.button_status = "retry";

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                console.log("requestResult error: ", _context.t0);
                this.button_status = "retry";

              case 15:
                _context.next = 18;
                break;

              case 17:
                this.dataIsOk = true;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));

      function watchStatus(_x) {
        return _watchStatus.apply(this, arguments);
      }

      return watchStatus;
    }()
  }, {
    key: "getMyReport",
    value: function getMyReport() {
      this.getReport && this.getReport();
      EventBus.$emit("isShowGetMyReport", {
        isShow: false
      });
    }
  }, {
    key: "endLoading",
    value: function endLoading() {
      this.updateResultByName({
        name: "maskShow",
        result: false
      });
      EventBus.$emit("isShowGetMyReport", {
        isShow: false
      });
    }
  }, {
    key: "retry",
    value: function () {
      var _retry = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.button_status = "loading";
                _context2.prev = 1;
                _context2.next = 4;
                return this.requestResult();

              case 4:
                result = _context2.sent;
                console.log("retry result", result);
                result && (this.dataIsOk = true);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);
                this.button_status = "retry";

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9]]);
      }));

      function retry() {
        return _retry.apply(this, arguments);
      }

      return retry;
    }()
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var animateName;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                animateName = this.animateName;

                if (animateName.indexOf("Ethnicity") > -1) {
                  // 绘制多边形背景
                  Sexangle({
                    el: "#Ethnicity_bg",
                    width: 188,
                    height: 188,
                    sideLength: 6
                  }); // 绘制图形动画

                  Radar({
                    el: "#Ethnicity",
                    width: 188,
                    height: 188,
                    sideLength: 6
                  });
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "paramsSection",
    get: function get() {
      return this.animateName && this.paramsMap[this.animateName];
    }
  }, {
    key: "retryButtonShow",
    get: function get() {
      return this.button_status !== "loading" && this.button_status !== "get";
    }
  }, {
    key: "loadingButtonShow",
    get: function get() {
      return this.button_status === "loading";
    }
  }, {
    key: "isVip",
    get: function get() {
      return GeneralUtilsHelper.isVip();
    }
  }, {
    key: "rateUsShowType",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.show_type;
    }
  }, {
    key: "rateUsVipCloseCount",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.vip_close_count;
    }
  }, {
    key: "rateUsSwitch",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.switch;
    }
  }, {
    key: "rateUsButtonShow",
    get: function get() {
      // return !this.isVip && this.vipCloseCount >= 3 && !this.rateUsStatus;
      return !this.isVip && this.rateUsSwitch && !this.rateUsStatus && this.vipCloseCount >= this.rateUsVipCloseCount;
    }
  }, {
    key: "rateUsForce",
    get: function get() {
      return this.settingData && this.settingData.client.rate_us && this.settingData.client.rate_us.rate_us_show && this.settingData.client.rate_us.rate_us_show.show_type === "force";
    }
  }]);

  return GetMyReport;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], GetMyReport.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Prop({
  default: null
})], GetMyReport.prototype, "goBack", void 0);

tslib_1.__decorate([Prop({
  default: null
})], GetMyReport.prototype, "getReport", void 0);

tslib_1.__decorate([Prop({
  default: false
})], GetMyReport.prototype, "iconColor", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "title", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "titleColor", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "headImg", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "animateName", void 0);

tslib_1.__decorate([Prop({
  default: null
})], GetMyReport.prototype, "rateUsFn", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "buttonStatus", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], GetMyReport.prototype, "loading_text", void 0);

tslib_1.__decorate([Prop({
  default: null
})], GetMyReport.prototype, "requestResult", void 0);

tslib_1.__decorate([Prop({
  default: false
})], GetMyReport.prototype, "changeData", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], GetMyReport.prototype, "updateResultByName", void 0);

tslib_1.__decorate([Getter(types.GETTER_VIP_CLOSE_COUNT)], GetMyReport.prototype, "vipCloseCount", void 0);

tslib_1.__decorate([Getter(types.GETTER_RATE_US_STATUS)], GetMyReport.prototype, "rateUsStatus", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], GetMyReport.prototype, "settingData", void 0);

tslib_1.__decorate([Watch("changeData", {
  immediate: true
})], GetMyReport.prototype, "watchStatus", null);

GetMyReport = tslib_1.__decorate([Component({
  components: {
    LoadingProgressBar: LoadingProgressBar,
    purpleButton: purpleButton,
    MyReportButton: MyReportButton,
    Nav: Nav
  }
})], GetMyReport);
export default GetMyReport;